import { Nothing } from 'components/Nothing';
import styles from './Taxes.module.scss';

export const Taxes = () => {
  return (
    <div className={styles.root}>
      <Nothing style={{ height: '660px' }} title='Ничего не найдено' />
    </div>
  );
};
